import { Stack } from "@mui/material";
import React from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const Introduction101 = ({ text, text2, text3, text4 }) => {
  const count1 = useMotionValue(0);
  const count2 = useMotionValue(0);
  const rounded1 = useTransform(count1, (latest) => Math.round(latest));
  const rounded2 = useTransform(count2, (latest) => Math.round(latest));
  const displayText1 = useTransform(rounded1, (latest) =>
    text.slice(0, latest)
  );
  const displayText2 = useTransform(rounded2, (latest) =>
    text2.slice(0, latest)
  );

  return (
    <Stack
      sx={{
        fontSize: {
          xs: "30px",
          sm: "30px",
          md: "44px",
          lg: "48px",
          xl: "48px",
        },

        lineHeight: {
          xs: "36px",
          sm: "36px",
          md: "52px",
          lg: "52px",
          xl: "52px",
        },
        fontWeight: { xs: 600, sm: 600, md: 600, lg: 600, xl: 600 },
        color: "#1e3a8a",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        textAlign: "center",
        marginBottom: {
          xs: "40px",
          sm: "40px",
          md: "40px",
          lg: "64px",
          xl: "56px",
        },
        paddingTop: {
          xs: "24px",
          sm: "40px",
          md: "40px",
          lg: "56px",
          xl: "56px",
        },
        fontFamily: "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
        // border: "1px solid red",
      }}
    >
      <Stack
        sx={{
          fontSize: {
            xs: "22px",
            sm: "26px",
            md: "30px",
            lg: "34px",
          },
          fontWeight: {
            xs: 600,
            sm: 600,
            md: 600,
            lg: 600,
            xl: 600,
          },
          fontFamily: "'Roboto', sans-serif",
          color: "#054E91",
          fontWeight: 600,
          letterSpacing: "0.5px",
          // border: "1px solid red",
          width: {
            lg: "80%",
            xl: "70%",
            md: "85%",
            xs: "90%",
            sm: "100%",
          },
          textAlign: "left",
          display: "flex",
          flexDirection: "row",
          marginBottom: { xl: "12px", lg: "12px", md: "12px" },
        }}
      >
        {" "}
        <Stack
          sx={{
            //  border: "1px solid red",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              width: { xl: "6px", lg: "6px", xs: "4px" },
              height: { xs: "22px", sm: "36px", md: "30px" },
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              border: "1px solid rgb(5 78 146)",
              // backgroundColor: "rgb(5 78 146)",
              backgroundColor: "rgb(5 78 146)",
              marginRight: {
                xs: "8px",
                sm: "8px",
                md: "12px",
                lg: "12px",
                xl: "12px",
              },
              borderTopRightRadius: "8px", // Adjust the value as needed
              borderBottomRightRadius: "8px", // Adjust the value as needed
            }}
          >
            <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
          </Stack>
        </Stack>
        <Stack>{text}</Stack>
      </Stack>

      <Stack
        sx={{
          // border: "1px solid red",
          fontSize: {
            xs: "15px",
            sm: "17px",
            md: "20px",
          },
          fontWeight: 400,
          lineHeight: { xs: 1.5, sm: 1.8, md: 1.2 },
          fontFamily: "'Roboto', sans-serif",
          color: "text.secondary",
          border: "1px solid #dae9f8",
          padding: 1,
          backgroundColor: "#dae9f8",
          borderRadius: "8px",
          width: {
            lg: "80%",
            xl: "70%",
            md: "85%",
            xs: "90%",
            sm: "100%",
          },
          marginTop: {
            lg: "4px",
            xl: "4px",
            md: "4px",
            xs: "12px",
            sm: "12px",
          },
          textAlign: "left",
          display: { xs: "none", sm: "flex" },
        }}
      >
        {" "}
        {text2}
      </Stack>

      <Stack
        display={{ xs: "flex", sm: "none" }}
        sx={{
          fontSize: {
            xs: "16px",
            sm: "18px",
            md: "16px",
            lg: "24px",
            xl: "24px",
          },
          fontWeight: {
            xs: 400,
            sm: 400,
            md: 400,
            lg: 400,
            xl: 400,
          },
          color: {
            xs: "#333",
            sm: "#333",
            md: "#333",
            lg: "#333",
            xl: "text.secondary",
          },
          lineHeight: {
            xs: "22px",
            sm: "28px",
            md: "32px",
            lg: "32px",
            xl: "32px",
          },
          border: "1px solid #dae9f8",
          padding: 1,
          backgroundColor: "#dae9f8",
          borderRadius: "8px",
          width: {
            lg: "80%",
            xl: "70%",
            md: "85%",
            xs: "90%",
            sm: "100%",
          },
          marginTop: {
            lg: "12px",
            xl: "12px",
            md: "12px",
            xs: "18px",
            sm: "12px",
          },
          textAlign: "left",
        }}
      >
        {" "}
        {text3}
      </Stack>
    </Stack>
  );
};

export default Introduction101;
